module.exports = __webpack_public_path__ + "static/media/nopic_lighter.daf95ff4.svg";